export default __webpack_public_path__ + "static/media/Background_00013.22aafabe.png";